import { render, staticRenderFns } from "./page-portfolio-grid.vue?vue&type=template&id=21d46424&"
import script from "./page-portfolio-grid.vue?vue&type=script&lang=js&"
export * from "./page-portfolio-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports